<h1 class="strong" mat-dialog-title>{{ 'header.userSettings.impersonation.impersonate' | translate }}</h1>
<div class="card-groups-container" mat-dialog-content>
  @if (isLoading() === false) {
    @let imitableUsers = imitableUsers$();
    @if (imitableUsers && imitableUsers?.length > 0) {
      <div class="card-container">
        <mat-form-field class="width-100" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ 'default.user' | translate }}</mat-label>
          <mat-select [ngModel]="selectedUser" (ngModelChange)="updateSelectedUser($event)">
            @for (user of imitableUsers; track user.parentGid) {
              @if (!isExpiredOrNotValidYet(user)) {
                <mat-option [value]="user">
                  {{ user.parentName }}
                </mat-option>
              }
            }
          </mat-select>
        </mat-form-field>
      </div>
    } @else {
      <p class="empty-impersonation-list">{{ 'header.userSettings.impersonation.empty-impersonation-list' | translate }}</p>
    }
  } @else {
    <app-loading [loadingMode]="LoadingMode.OVERLAY" />
  }
</div>
<div mat-dialog-actions>
  <button class="btn btn-secondary" (click)="closeDialog()">{{ 'shared.cancel' | translate }}</button>
  <button class="btn btn-primary" [disabled]="!selectedUser" (click)="confirm()">
    {{ 'default.apply' | translate }}
  </button>
</div>
